import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '@/hooks/use-auth';
import { getUserFeatureFlags } from '@/lib/api/feature-flags';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext';
/**
 * Loads the authenticated user's feature flags once auth resolves and exposes
 * them via context. Caches results for 5 minutes; components read via
 * `useFeatureFlag(key)`.
 */
export function FeatureFlagProvider({ children }) {
    const { isAuthenticated } = useAuth();
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['featureFlags'],
        queryFn: getUserFeatureFlags,
        staleTime: 5 * 60 * 1000,
        enabled: isAuthenticated,
    });
    const value = useMemo(() => ({
        flags: data?.flags ?? {},
        isLoading: isAuthenticated && isLoading,
        isError,
        refetch: async () => {
            await refetch();
        },
    }), [data, isAuthenticated, isLoading, isError, refetch]);
    return _jsx(FeatureFlagContext.Provider, { value: value, children: children });
}
